import React from "react"
import { ButtonPrimary } from "../../components/Buttons.js"


/**
 * Shared settings-section button — a rounded primary button.
 * Used by every section in Slide_Settings/.
 */
const ButtonParam = ({ children, onClick, style, ...otherProps }) => {
	return (
		<ButtonPrimary
			onClick={onClick}
			style={{ borderRadius: "100px", padding: "10px 20px", ...style }}
			{...otherProps}
		>
			{children}
		</ButtonPrimary>
	)
}

export default ButtonParam
